export default __webpack_public_path__ + "static/media/2202.f1ab1b8b.png";